import React from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { SiteCoreDictionary } from '../../types';

interface HeaderProps {
    setShowModal: (value: boolean) => void;
    dictionary: SiteCoreDictionary;
}

export default ({ setShowModal, dictionary }: HeaderProps) => {
    const { regionTitleText, regionTitle2Text, regionQuestion2DescriptionText } = dictionary;

    return (
        <div>
            <div className="region-info-header">
                <h3>{regionTitle2Text}</h3>
                <IconButton
                    screenReaderText={regionTitle2Text}
                    aria-label={`Info om ${regionTitleText.toLowerCase()}`}
                    icon={IconTypes.INFO_24}
                    onClick={() => setShowModal(true)}
                />
            </div>
            <p className="description">{regionQuestion2DescriptionText}</p>
        </div>
    );
};
